import React from 'react';
import { Redirect } from 'react-router-dom';
import { paths } from 'routes/paths';
import WorkOrdersIcon from 'assets/WorkOrdersIcon';
import useOperationFlags from '../Hooks/useOperationFlags';
import useWorkOrdersSummary from './Hooks/useWorkOrdersSummary';
import { OperationType } from '../RouteAdmin';
import { OperationsPageProvider } from '../Components/OperationsPage';

const WorkOrdersPage = () => {
  const { feWorkOrdersActive } = useOperationFlags();

  if (!feWorkOrdersActive) {
    return <Redirect to={paths.tasks} />;
  }

  return (
    <OperationsPageProvider
      config={{
        icon: <WorkOrdersIcon />,
        title: 'Work Orders',
        breadcrumbTitle: 'Work Orders',
        breadcrumbValue: 'All Work Orders',
        searchPlaceholder: 'Search work orders',
        emptyMessage: 'No Work Orders found.',
        emptyStateTitle: 'No Work Orders Found',
        emptyStateMessage: 'Create a Work Order or change the selected season.',
        createButtonLabel: 'Create Work Order',
        cropZoneMessage:
          'Create a crop zone to proceed with adding Work Orders.',
        operationType: OperationType.WORK_ORDER,
        createPath: paths.workOrders,
        storageKey: 'work-orders'
      }}
      useSummaryHook={useWorkOrdersSummary as any}
    />
  );
};

export default WorkOrdersPage;
